import { Divider, Progress } from "antd";
import React, { useState } from "react";
import Settings from "./Settings";
import BriefData from "./BriefData";
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
 import {Actions} from '../../../Action/index';
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import TooltipComp from "../../../NewComponent/ToolTip/TooltipComp";
export default function Container() {
  const userState = useSelector((state) => state.user);
  const briefState = useSelector((state) => state.brief);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(0);
  const {briefPanningBreakdownChange} = bindActionCreators(Actions, dispatch);
  const onChangeOpen=(val)=>{
    if(val===open){
      setOpen(2);
    }else{
    setOpen(val)
    }
  }
  const  calculatePercentage=(value, total)=> {
  if (total === 0) {
    throw new Error("Total cannot be zero");
  }
  return (value / total) * 100;
}
  return (
    <div style={containerStyles}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          border: "none",
          padding: "8px",
          borderTopLeftRadius: "32px",
          borderTopRightRadius: "32px",
          background:
            "linear-gradient(90.39deg, #227ED4FF 0.34%, #4B4BC9FF 99.7%)",
          color: "#fff",
        }}
      >
        <span style={{ margin: "5px" }}>
          <img
            style={{ width: "40px", borderRadius: "25px" }}
            src={require("../../../Images/vizerto_icon.jpg")}
          />
        </span>
        <span
          style={{ fontSize: "24px", fontWeight: "500", lineHeight: "28px" }}
        >
          &nbsp;&nbsp;Vizerto Briefing Agent
        </span>
      </div>
      <div style={{ height: "280px", overflow: "auto", padding: "20px" }}>
        {!briefState.isLoading && briefState.phase === 0 && !briefState.fromSearch && (
          <div>
            <div style={colorText}>Hello {userState.firstName},</div>
            <div style={normalText}> I’m here to help.</div>
            <div style={normalText}>
              What information or details would be most useful for a briefing on
              a specific topic?
            </div>
            <div style={normalText}>
              I can provide insights on products, features, and company-specific
              information based on what I’ve learned.
            </div>
          </div>
        )}
        {!briefState.isLoading && briefState.phase === 0 && briefState.fromSearch && (
          <div>
            <div style={colorText}>Hello {userState.firstName},</div>
            <div style={normalText}>
              Please add more context to your question below, and confirm which of the sources listed should be used for your briefing
            </div>
            {/* <div style={normalText}>
              I can provide insights on products, features, and company-specific
              information based on what I’ve learned.
            </div> */}
          </div>
        )}
        {briefState.isLoading && briefState.phase === 1 && (
          <div>
            <div style={normalText}>
              Planning the steps to prepare your briefing. This may take a few
              minutes...
            </div>
          </div>
        )}
        {!briefState.isLoading && briefState.phase === 1 && (
          <div>
            <div
              style={textStyles3}
              dangerouslySetInnerHTML={{ __html: briefState.planningBreakdown }}
            ></div>
          </div>
        )}
        {!briefState.isLoading && briefState.phase === 2 && (
          <div>
            <ReactQuill
              theme="snow"
              value={briefState.planningBreakdown}
              // style={{ height: "35vh" }}
              onChange={(e) => briefPanningBreakdownChange(e)}
            />
          </div>
        )}
        {briefState.phase === 3 && (
          <div>
            <div
              style={textStyles3}
              dangerouslySetInnerHTML={{ __html: briefState.response }}
            ></div>
          </div>
        )}
      </div>
      <div>
        <div style={{marginBottom:`${open===2?'10px':'0px'}`}}>
          <Divider style={{ margin: "0px",marginBottom:'10px', background: "#edeff2" }} />
          <span style={{paddingInline:'20px', cursor:'pointer', fontWeight:'500'}}><span style={open===0?colorText2:normalText} onClick={()=>onChangeOpen(0)}>Sources</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={open===1?colorText2:normalText} onClick={()=>onChangeOpen(1)}>Settings</span></span>
          <span style={{float:'inline-end',paddingRight:'20px'}}>
            <span style={normalText}>Weekly Tokens&nbsp;<TooltipComp title={()=>{
              return(
                <>
                <div>Token count: {userState.usedBriefCount}/{userState.briefThreshold}</div>
                <div>Reset every week</div>
                </>
              )
            }}><Progress size={'large'} strokeColor="linear-gradient(90.39deg, rgb(34, 126, 212) 0.34%, rgb(75, 75, 201) 99.7%)" percent={calculatePercentage(userState.usedBriefCount,userState.briefThreshold)} style={{width:'100px', cursor:'pointer'}} showInfo={false} /></TooltipComp></span>
          </span>
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        {open === 1 && (
          <div>
            <Settings />
          </div>
        )}
        {open === 0 && (
          <div>
            <BriefData />
          </div>
        )}
      </div>
    </div>
  );
}
const containerStyles = {
  // border: '1px solid #EAECF0',
  boxShadow: "0px 0px 20px 2px #00000040",
  borderRadius: "32px",
  background: "white",
  // padding:'24px',
  // height:'69vh'
};
const colorText = {
  background:
    "linear-gradient(90deg, #00D1FF 0%, #BD00FF 15.98%, #0075FF 29.15%, #00E0FF 43.18%)",
  backgroundClip: "text",
  "-webkit-text-fill-color": "transparent",
  "-moz-text-fill-color": "transparent",
  "-ms-text-fill-color": "transparent",
  "-o-text-fill-color": "transparent",
  fontSize: "22px",
  fontWeight: "500",
  lineHeight: "30px",
};

const normalText = {
  fontSize: "18px",
  fontWeight: "300",
  lineHeight: "30px",
  color: "#5C667B",
};
const textStyles3 = {
  fontSize: "16px",
  color: "#5C667B",
  lineHeight: "32px",
  fontWeight: "300",
  wordBreak: "break-word",
  overflowWrap: "break-word",
};

const colorText2 = {
  color:'#00A3FF',
  fontSize: "18px",
  fontWeight: "500",
  lineHeight: "26px",
  fontWeight:'500'
};
